import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectPresets = (store: StoreSchema) => store.product.productData.functionalitiesPresets
